import theme from "../theme";
import {Link} from "react-router-dom";
import React from "react";
import {
    COT_ROLE,
    DISTRICT_ROLE,
    NATIONAL_ROLE,
    PROMOTER_ROLE,
    QUERY_STATE_ROLE,
    SECTIONAL_ROLE,
    STATE_ROLE
} from "../utils/userSessionUtils";

const createMenuItems = (linkColor) => ({
    HOME: {
        key: "1",
        path: "/",
        labelText: "Inicio",
        icon: <i className="bi bi-house" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: <Link to="/" style={{color: linkColor}}>Inicio</Link>,
    },
    PEOPLE: {
        key: "people",
        labelText: "Convencidos",
        icon: <i className="bi bi-person-check" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: "Convencidos",
        children: [
            {
                key: "people-new",
                path: "/registro",
                label: <Link to="/registro" style={{color: linkColor}}>Nuevo</Link>,
            },
            {
                key: "people-list",
                path: "/personas",
                label: <Link to="/personas" style={{color: linkColor}}>Listado</Link>,
            }
        ]
    },
    PROMOTERS: {
        key: "promoters",
        labelText: "Promotores",
        icon: <i className="bi bi-people" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: "Promotores",
        children: [
            {
                key: "promoters-new",
                path: "/promotores/nuevo",
                label: <Link to="/promotores/nuevo" style={{color: linkColor}}>Nuevo</Link>,
            },
            {
                key: "promoters-list",
                path: "/promotores",
                label: <Link to="/promotores" style={{color: linkColor}}>Listado</Link>,
            }
        ]
    },
    SECTIONALS: {
        key: "sectionals",
        labelText: "Seccionales",
        icon: <i className="bi bi-person-square" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: "Seccionales",
        children: [
            {
                key: "sectionals-list",
                path: "/seccionales",
                label: <Link to="/seccionales" style={{color: linkColor}}>Listado</Link>,
            }
        ]
    },
    REPORTS: {
        key: "reports",
        labelText: "Reportes",
        icon: <i className="bi bi-bar-chart-line" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: "Reportes",
        children: [
            {
                key: "reports-goals",
                path: "/metas-dashboard",
                label: <Link to="/metas-dashboard" style={{color: linkColor}}>Convencidos</Link>,
            },
            {
                key: "reports-goals-promoters",
                path: "/metas-promotores-dashboard",
                label: <Link to="/metas-promotores-dashboard" style={{color: linkColor}}>Promotores</Link>,
            },
            {
                key: "reports-promotion-progress",
                path: "/reporte-promocion",
                label: <Link to="/reporte-promocion" style={{color: linkColor}}>Avance de Promoción</Link>,
            }
        ]
    },
    REPORTS_WITH_PROMO: {
        key: "reports",
        labelText: "Reportes",
        icon: <i className="bi bi-bar-chart-line" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: "Reportes",
        children: [
            {
                key: "reports-goals",
                path: "/metas-dashboard",
                label: <Link to="/metas-dashboard" style={{color: linkColor}}>Convencidos</Link>,
            },
            {
                key: "reports-goals-promoters",
                path: "/metas-promotores-dashboard",
                label: <Link to="/metas-promotores-dashboard" style={{color: linkColor}}>Promotores</Link>,
            },
            {
                key: "reports-promotion-progress",
                path: "/reporte-promocion",
                label: <Link to="/reporte-promocion" style={{color: linkColor}}>Avance de Promoción</Link>,
            }
        ]
    },
    REPORTS_PROMOTER: {
        key: "reports",
        labelText: "Reportes",
        icon: <i className="bi bi-bar-chart-line" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: "Reportes",
        children: [
            {
                key: "reports-promotion-progress",
                path: "/reporte-promocion",
                label: <Link to="/reporte-promocion" style={{color: linkColor}}>Avance de Promoción</Link>,
            }
        ]
    },
    ROLL_CALL: {
        key: "roll-call",
        path: "/pase-de-lista",
        labelText: "Pase de Lista",
        icon: <i className="bi bi-person-check-fill" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: <Link to="/pase-de-lista" style={{color: linkColor}}>Pase de Lista</Link>,
    },
    AFFILIATE_ROLL_CALL: {
        key: "affiliate-roll-call",
        path: "/afiliados",
        labelText: "Afiliados",
        icon: <i className="bi bi-people-fill" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: <Link to="/afiliados" style={{color: linkColor}}>Afiliados</Link>,
    },
    AVANCE_ASISTENCIA: {
        key: "avance-asistencia",
        path: "/avance-asistencia",
        labelText: "Avance",
        icon: <i className="bi bi-clipboard2-data" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: <Link to="/avance-asistencia" style={{color: linkColor}}>Avance Asistencia</Link>,
    },
    DIRECTORY: {
        key: "directory",
        path: "/directory",
        labelText: "Directorio",
        icon: <i className="bi bi-file-text" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: <Link to="/directory" style={{color: linkColor}}>Directorio</Link>,
    },
    DIRECTORY_SURVEY: {
        key: "directory-survey",
        path: "/directory-survey",
        labelText: "Directorio",
        icon: <i className="bi bi-clipboard-data" style={{color: theme.colors.card, fontSize: '16px'}}></i>,
        label: <Link to="/directory-survey" style={{color: linkColor}}>Directorio</Link>,
    },
});

const getMenuItemsByRole = (role, group = "", linkColor = theme.colors.card) => {
    const menuItems = createMenuItems(linkColor);
    const isEstructura = group.toLowerCase() === "estructura";
    let userMenu;
    const affiliateItem = isEstructura ? [menuItems.AFFILIATE_ROLL_CALL] : [];
    const avanceItem = isEstructura ? [menuItems.AVANCE_ASISTENCIA] : [];
    if (role === PROMOTER_ROLE) {
        userMenu = [menuItems.HOME, menuItems.PEOPLE, menuItems.ROLL_CALL, ...affiliateItem, menuItems.REPORTS_PROMOTER];
    } else if (role === SECTIONAL_ROLE) {
        userMenu = [menuItems.HOME, menuItems.PEOPLE, menuItems.PROMOTERS, menuItems.SECTIONALS, menuItems.ROLL_CALL, ...affiliateItem, menuItems.REPORTS, menuItems.DIRECTORY_SURVEY];
    } else if (role === COT_ROLE) {
        userMenu = [menuItems.HOME, menuItems.PEOPLE, menuItems.PROMOTERS, menuItems.SECTIONALS, menuItems.ROLL_CALL, ...affiliateItem, menuItems.REPORTS, menuItems.DIRECTORY_SURVEY];
    } else if (role === DISTRICT_ROLE) {
        userMenu = [menuItems.HOME, menuItems.PROMOTERS, menuItems.SECTIONALS, menuItems.ROLL_CALL, ...affiliateItem, ...avanceItem, menuItems.REPORTS_WITH_PROMO, menuItems.DIRECTORY_SURVEY];
    } else if (role === STATE_ROLE || role === QUERY_STATE_ROLE) {
        userMenu = [menuItems.HOME, menuItems.ROLL_CALL, ...affiliateItem, ...avanceItem, menuItems.REPORTS, menuItems.DIRECTORY_SURVEY];
    } else if (role === NATIONAL_ROLE) {
        userMenu = [menuItems.HOME, ...avanceItem, menuItems.REPORTS, menuItems.DIRECTORY_SURVEY];
    } else {
        userMenu = [menuItems.HOME];
    }

    return userMenu;
}

const getMenuItemsByRoleAndEntity = (role, entity, linkColor = theme.colors.card, group = "") => {
    return getMenuItemsByRole(role, group, linkColor);
}

export {getMenuItemsByRole, getMenuItemsByRoleAndEntity};
